import { ActivityFeedEventIdEnum, ActivityMailEventType } from '@ukpostbox/client-data/lib/Types/ClientTypes';
import { ListItem, useLayout } from '@ukpostbox/frontend-framework';
import { FormatLocaleRelativeStrict } from '@ukpostbox/helpers';
import React from 'react';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';
import { MailItemThumbnail } from '../../../Mailboxes/Components/Thumbnails/Entries/MailItemThumbnail';
import { MailItemTopUpRequiredThumbnail } from '../../../Mailboxes/Components/Thumbnails/Entries/MailItemTopUpRequiredThumbnail';
import { MailItemNoThumbnail } from '../../../Mailboxes/Components/Thumbnails/Entries/MailItemNoThumbnail';
import { MailPartTypeEnum } from '../../../Mailboxes/Components/Thumbnails/Types/ThumbnailTypes';

function ActivityEventMail(item: ActivityMailEventType) {
	const { currentLocale } = useSite();
	const { isTiny, isSmall } = useLayout();

	return (
		<ListItem
			actionLink={{ url: `./mail/inbox/${item.metadata.mailUuid}` }}
			addonLeft={
				<>
					{(item.eventId === ActivityFeedEventIdEnum.LetterReceived ||
						item.eventId === ActivityFeedEventIdEnum.ParcelReceived ||
						item.eventId === ActivityFeedEventIdEnum.ContentScanned) &&
						(item.metadata.envelopeThumbnails?.topupRequired ||
							item.metadata.contentThumbnails?.topupRequired) && <MailItemTopUpRequiredThumbnail />}

					{(item.eventId === ActivityFeedEventIdEnum.LetterReceived ||
						item.eventId === ActivityFeedEventIdEnum.ParcelReceived ||
						item.eventId === ActivityFeedEventIdEnum.ContentScanned) &&
						item.metadata.envelopeThumbnails &&
						!item.metadata.contentThumbnails &&
						!item.metadata.envelopeThumbnails?.topupRequired && (
							<MailItemThumbnail {...item.metadata.envelopeThumbnails?.thumbnails[0]} />
						)}

					{(item.eventId === ActivityFeedEventIdEnum.LetterReceived ||
						item.eventId === ActivityFeedEventIdEnum.ParcelReceived ||
						item.eventId === ActivityFeedEventIdEnum.ContentScanned) &&
						item.metadata.contentThumbnails &&
						!item.metadata.contentThumbnails?.topupRequired && (
							<MailItemThumbnail {...item.metadata?.contentThumbnails?.thumbnails[0]} />
						)}

					{(item.eventId === ActivityFeedEventIdEnum.LetterReceived ||
						item.eventId === ActivityFeedEventIdEnum.ParcelReceived ||
						item.eventId === ActivityFeedEventIdEnum.ContentScanned) &&
						!item.metadata.envelopeThumbnails &&
						!item.metadata.contentThumbnails && (
							<MailItemNoThumbnail
								mailType={
									item.metadata.contentThumbnails
										? MailPartTypeEnum['Mail-Contents']
										: MailPartTypeEnum['Mail-Envelopes']
								}
							/>
						)}
				</>
			}
			title={item.message}
			description={isTiny || isSmall ? FormatLocaleRelativeStrict(item.eventDate, currentLocale) : undefined}
			addonRight={
				!isTiny && !isSmall ? { content: FormatLocaleRelativeStrict(item.eventDate, currentLocale) } : undefined
			}
		/>
	);
}

export { ActivityEventMail };
